<template>
  <div>
    <b-alert
      v-if="!isFormValid"
      variant="danger"
      class="mb-3"
      show
      dismissible
    >
      You have to set a start date and end date before publishing the campaign.
    </b-alert>
    <advanced-form
      autocomplete="off"
      layout="inline-md-3"
      :submit-label="$t('content-fetch.buttons.update-campaign')"
      v-bind="formFields"
      v-model="form"
      @submit="input()"
    />
  </div>
</template>

<script>
import AdvancedForm from '@src/components/AdvancedForm';
import UpdateCampaignMutation from '@/graphql/mutations/UpdateCampaign.gql';

export default {
  props: {
    campaign: {
      type: Object,
    },
  },
  components: {
    AdvancedForm,
  },
  data: () => ({
    form: {},
  }),
  created() {
    const { campaign: { title, status, startDate, endDate, preferences } } = this;
    const { canScheduleLinkedInPosts, showRecruitersOnLeaderboards } = preferences || {};
    this.form = {
      title,
      status,
      startDate,
      endDate,
      'preferences.canScheduleLinkedInPosts': !!canScheduleLinkedInPosts,
      'preferences.showRecruitersOnLeaderboards': !!showRecruitersOnLeaderboards,
    };
  },
  computed: {
    formFields() {
      const form = {
        title: {
          label: this.$t('content-fetch.labels.title'),
          type: 'STRING',
          helpText: this.$t('campaign-admin.hints.title')
        },
        startDate: {
          label: this.$t('content-fetch.labels.start-date'),
          placeholder: this.$t('campaign-admin.placeholders.end-date'),
          helpText: this.$t('campaign-admin.hints.start-date'),
          type: 'DATETIME',
        },
        endDate: {
          label: this.$t('content-fetch.labels.end-date'),
          placeholder: this.$t('campaign-admin.placeholders.start-date'),
          helpText: this.$t('campaign-admin.hints.end-date'),
          type: 'DATETIME',
        },
        status: {
          label: this.$t('onboarding.slack.labels.status'),
          type: 'SELECT',
          required: true,
          choices: {
            DRAFT: this.$t('campaign-admin.labels.draft'),
            READY: this.$t('campaign-admin.labels.ready'),
            IN_PROGRESS: this.$t('campaign-admin.labels.in-progress'),
            FINISHED: this.$t('campaign-admin.labels.finished'),
            ARCHIVED: this.$t('campaign-admin.labels.archived'),
          },
        },
        'preferences.canScheduleLinkedInPosts': {
          description: this.$t('campaign-admin.labels.schedule-linked-in'),
          type: 'CHECKBOX',
        },
        'preferences.showRecruitersOnLeaderboards': {
          description: this.$t('campaign-admin.labels.show-recruiters'),
          type: 'CHECKBOX',
        },
      };

      return { form };
    },
    isFormValid() {
      const { status, startDate, endDate } = this.form;
      return ![ 'READY', 'IN_PROGRESS' ].includes(status) || (startDate && endDate);
    },
  },
  methods: {
    async input() {
      const { isFormValid } = this;
      if (!isFormValid) return;
      try {
        const { id: campaignID } = this.campaign;
        const { title, status, startDate, endDate } = this.form;
        await this.$apollo.mutate({
          mutation: UpdateCampaignMutation,
          variables: {
            where: { id: campaignID },
            update: {
              title,
              status,
              startDate,
              endDate,
              preferences: {
                canScheduleLinkedInPosts: !!this.form['preferences.canScheduleLinkedInPosts'],
                showRecruitersOnLeaderboards: !!this.form['preferences.showRecruitersOnLeaderboards'],
              },
            },
          },
        });
        this.$emit('updated');
      } catch (err) {
        this.$log.error(err);
        this.$notification({
          title: 'An error occurred',
          message: err.message,
          variant: 'danger',
        });
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/campaign-admin/update-campaign-details.vue